// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"b5-z","displaySixCardTiles":"c5-z"};